import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import { getMpfTransicoesDaNoticia } from 'volto-ministerio-publico-federal/actions';
import { idDaTransicao } from 'volto-ministerio-publico-federal/helpers/Notificacoes';

const TRANSICAO = 'enviar_revisao_nacional';

/**
 * O usuário pode enviar a notícia à publicação nacional AGORA? O `@workflow`
 * lista só as transições do estado atual permitidas a ele, o que cobre tanto
 * quem não é editor quanto a notícia que já seguiu adiante.
 *
 * `habilitado` falso não consulta nada; `verificar` falso confia em quem
 * chamou (a Minha fila, que o backend já filtra por permissão).
 */
export const usePodeSolicitarNacional = (
  url: string,
  habilitado: boolean,
  verificar = true,
): boolean => {
  const dispatch: any = useDispatch();
  const path = flattenToAppURL(url);
  const [pode, setPode] = useState(habilitado && !verificar);

  useEffect(() => {
    if (!habilitado || !verificar) return undefined;
    let ativo = true;
    dispatch(getMpfTransicoesDaNoticia(path))
      .then((resposta: any) => {
        const permitido = (resposta?.transitions || []).some(
          (t: any) => idDaTransicao(t['@id']) === TRANSICAO,
        );
        if (ativo) setPode(permitido);
      })
      .catch(() => {});
    return () => {
      ativo = false;
    };
  }, [dispatch, habilitado, verificar, path]);

  return habilitado && pode;
};

type Props = {
  /** URL da notícia publicada localmente. */
  url: string;
  titulo: string;
  onClick?: () => void;
};

/**
 * "Solicitar" (publicação nacional), embaixo da etapa pontilhada. Leva à
 * página da notícia, onde o usuário confere o conteúdo e faz a transição
 * pelo menu de estado da toolbar.
 */
const SolicitarNacional = ({ url, titulo, onClick }: Props) => (
  <UniversalLink
    href={flattenToAppURL(url)}
    className="mpf-notificacoes__solicitar"
    onClick={onClick}
    aria-label={`Solicitar publicação nacional: ${titulo}`}
  >
    Solicitar
  </UniversalLink>
);

export default SolicitarNacional;
